import { FEATURE_FLAG_DOMAIN } from '@heidi/runtime/feature-flags';
import { OpenFeature, useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Umbrella kill switch for desktop recording liveness safety:
 * - {@link DesktopRecordingLivenessPoll} convergence while capture is dead
 * - stop-tail chunk-count truncation heuristic (`captureTruncatedByChunks`)
 *
 * Default OFF — a false positive irreversibly aborts a recording and blocks
 * note generation on desktop, and rollback needs a full app release. Explicit
 * `captureTruncated: true` from a future caller is unaffected; with the flag
 * OFF the poll does not run.
 *
 * Kill switch, not an experiment — do NOT add `useManualExposure`.
 */
export const DESKTOP_RECORDING_LIVENESS_FLAG_KEY =
  'release-apps-desktop-recording-liveness-desktop';

export const useIsDesktopRecordingLivenessEnabled = (): boolean => {
  return useBooleanFlagValue(DESKTOP_RECORDING_LIVENESS_FLAG_KEY, false);
};

/**
 * Imperative read for mutation callbacks (same pattern as
 * {@link isSelfHealingStopEnabled}).
 */
export const isDesktopRecordingLivenessEnabled = (): boolean => {
  return OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    DESKTOP_RECORDING_LIVENESS_FLAG_KEY,
    false
  );
};
